<template>
  <div>
    <app-bar>
      <back-button goBackTo="/account" />
    </app-bar>

    <list-header title="Add Card" />
    <form @submit.prevent="handleSubmit" class="style-payment-form">
      <stripe-payment-form
        :elements="elements"
        v-model:billingCountry="billingCountry"
        @completed="setSetupFormStatus"
      />

      <default-button
        title="Submit"
        class="mt-5"
        :disabled="!submitButtonEnabled"
      />
    </form>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import ListHeader from "@/components/ListHeader";
import StripePaymentForm from "@/components/onlinePayment/StripePaymentForm";
import DefaultButton from "@/components/button/DefaultButton";
import { setupIntent } from "@/services/stripe";
import { mapGetters, mapMutations } from "vuex";
import { useToast } from "vue-toastification";
import BackButton from "@/components/button/BackButton";
import AppBar from "@/components/AppBar.vue";
import { accountType } from "@/common/constant/Stripe";

export default {
  name: "MyAccount",
  components: {
    ListHeader,
    StripePaymentForm,
    DefaultButton,
    BackButton,
    AppBar,
  },
  data() {
    return {
      stripe: null,
      elements: null,
      submitButtonEnabled: false,
      clientSecret: null,
      billingCountry: null,
    };
  },
  computed: {
    stripeAccount() {
      const stripeAccount = this.paymentMethods.find((paymentMethod) => {
        return (
          paymentMethod?.type === "GW" &&
          paymentMethod?.gateway.provider === "ST" &&
          paymentMethod?.gateway?.key2 === "card"
        );
      });
      return stripeAccount?.gateway?.key1 || "";
    },
    stripePublicKey() {
      return process.env.VUE_APP_STRIPE_PUBLIC_KEY;
    },
    ...mapGetters(["loginUserInfo", "paymentMethods", "selectedBranch"]),
  },
  methods: {
    async handleSubmit() {
      this.showLoading(true);
      const cardNumberElement = this.elements.getElement("cardNumber");
      const { error } = await this.stripe.confirmCardSetup(this.clientSecret, {
        payment_method: {
          card: cardNumberElement,
          billing_details: {
            address: {
              country: this.billingCountry,
            },
          },
        },
      });
      if (error) {
        console.log(error);
        useToast().success("Oops! Something went wrong. Please try again.");
      } else {
        useToast().success("Add Card Successfully.");
      }
      this.$router.push("/account/card");
      this.showLoading(false);
    },
    setSetupFormStatus(event) {
      this.submitButtonEnabled = event;
    },
    async stripeSetupIntent() {
      Promise.all([this.loadStripe()]);
      const { data } = await setupIntent({
        branchId: this.selectedBranch.id,
      });
      this.clientSecret = data.client_secret;
    },
    async loadStripe() {
      try {
        // Check if it is stripe standard
        if (this.stripeAccount.type === accountType.STANDARD) {
          this.stripe = await loadStripe(this.stripePublicKey, {
            stripeAccount: this.stripeAccount,
          });
        } else {
          this.stripe = await loadStripe(this.stripePublicKey);
        }
        this.elements = this.stripe.elements();
      } catch (error) {
        console.log(error);
      }
    },
    ...mapMutations(["showLoading"]),
  },
  created() {
    this.stripeSetupIntent();
  },
};
</script>
<style scoped>
.style-payment-form {
  width: 90%;
  margin: auto;
}
</style>
